import { useQuery as m } from "./contact-channels37.js";
import { useContactChannelsContext as A } from "./contact-channels14.js";
import { useTranslations as w } from "./contact-channels38.js";
import f from "./contact-channels50.js";
import "./contact-channels51.js";
const T = (o = !0) => {
  const { locale: r, whatsAppConfig: n } = A(), { t } = w();
  return m({
    queryKey: ["whatsApp"],
    queryFn: async () => {
      const e = n[r] || n["en-gb"], s = f.now().setZone(e.timezone);
      console.info("time now", s.toISO());
      const a = s.hour + s.minute / 60, c = s.weekday >= 1 && s.weekday <= 5, l = a >= e.hours.start && a <= e.hours.end, p = o && c && l, i = t(p ? "whatsApp.online.description" : "whatsApp.offline.description"), u = t("whatsApp.welcome_message"), h = `https://wa.me/${e.phoneNumber}?text=${u}`;
      return p ? {
        isAvailable: !0,
        plainData: {
          scheduleMessage: i,
          phoneNumber: e.phoneNumber,
          schedule: e.schedule,
          link: h
        },
        ui: {
          title: t("whatsApp.title"),
          description: i
        }
      } : {
        isAvailable: !1,
        availabilityInfo: {
          reason: "OUT_OF_BUISNESS_HOURS"
        },
        ui: {
          title: t("whatsApp.title"),
          description: i
        }
      };
    },
    staleTime: 5 * 60 * 1e3,
    gcTime: 5 * 60 * 1e3,
    enabled: o
  });
};
export {
  T as useWhatsApp
};
//# sourceMappingURL=contact-channels7.js.map
